<template>
  <adminTable
    :hideSeachButton="false"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item label="">
        <el-input
          v-model="searchForm.username"
          placeholder="请输入用户名"
          clearable
        />
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="searchForm.phone"
          placeholder="请输入手机号"
          clearable
        />
      </el-form-item>
      <el-form-item label="">
        <el-select
          v-model="searchForm.is_test"
          placeholder="请选择账号类型"
          clearable
        >
          <el-option
            v-for="item in accountTypeEnums"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="searchForm.starttime"
          type="datetime"
          placeholder="选择开始时间"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="searchForm.endtime"
          type="datetime"
          placeholder="选择结束时间"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.id }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.uid }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户名" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.username }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.phone }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="is_test" label="账号类型" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ getLabelByVal(scope.row.is_test, accountTypeEnums) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="img" label="图片" width="200">
        <template #default="scope">
          {{ scope.row.img ? "" : "--" }}
          <el-image
            v-if="scope.row.img"
            class="previewImg"
            :preview-teleported="true"
            :src="proxy.IMG_BASE_URL + scope.row.img"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            :preview-src-list="[proxy.IMG_BASE_URL + scope.row.img]"
            show-progress
            :initial-index="0"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column prop="class_id" label="股权ID" width="130" />
      <el-table-column prop="class_name" label="股权名称" width="130" />
      <el-table-column prop="cycle_start" label="周期开始" width="130" />
      <el-table-column prop="cycle_end" label="周期结束" width="130" />
      <el-table-column prop="status" label="状态" width="130">
        <template #default="scope">
          {{ getLabelByVal(scope.row.status, stocksStatusEnums) }}
        </template>
      </el-table-column>
      <el-table-column prop="shares" label="股权" width="130" />
      <el-table-column prop="money" label="每股的钱" width="130" />
      <el-table-column prop="create_at" label="创建时间" width="130" />
      <el-table-column prop="update_at" label="更新时间" width="130" />

      <el-table-column
        label="操作"
        fixed="right"
        width="200"
        v-if="currentUser.role == 0"
      >
        <template #default="scope">
          <el-button
            type="danger"
            icon="Delete"
            v-permission
            @click="deleteAction(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </template>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted, reactive } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  accountTypeEnums,
  stocksStatusEnums,
  getLabelByVal,
} from "../../config/enums";

const dialogFlag = ref(false);
const editFormRef = ref(false);
const editRow = ref({});
const formType = ref("add");
const searchForm = reactive({
  username: "",
  phone: "",
  is_test: "",
  starttime: "",
  endtime: "",
});

onMounted(() => {
  getList();
});

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);
const getList = async () => {
  tableLoading.value = true;
  const params = {
    page: page.value,
    limit: limit.value,
  };
  
  // 添加搜索条件
  if (searchForm.username) params.username = searchForm.username;
  if (searchForm.phone) params.phone = searchForm.phone;
  if (searchForm.is_test !== "") params.is_test = searchForm.is_test;
  if (searchForm.starttime) params.starttime = searchForm.starttime;
  if (searchForm.endtime) params.endtime = searchForm.endtime;
  
  const res = await proxy.$http({
    type: "get",
    url: "/Shares/getSharesLogLists",
    params,
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};

const editItem = (type, row) => {
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "/Shares/deleteSharesLogLists?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({
        type: "success",
        message: res.msg,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};
</script>

<style lang="less" scoped></style>
